import AIOApis from "./../../components/aio/aio-apis"
import { FC, useEffect, useRef, useState } from "react"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import usePopup from "./../../components/aio/aio-popup"
import "./index.css"
type I_key = {
  fa?: string
  en?: string
  defaultValue: any
  nullValue?: (index: number) => any
}
type I_error = { recordIndex: number; error: string; field: string }
type I_dic = {
  en2fa: { [key: string]: string }
  fa2en: { [key: string]: string }
}
type I_BoxitExcel = {
  keys: I_key[]
  onClose: () => void
  validateUrl: string
  onSuccess: (json: any) => void
  extendRowToServer: (row: any, index: number) => any
  errorStyle?: { [cssProp: string]: string | number }
}
class BoxitExcel {
  props: I_BoxitExcel
  constructor(p: I_BoxitExcel) {
    this.props = p
  }
  downloadTemplate = (type?: "en" | "fa") => {
    const cc = new AIOConvert()
    cc.getTemplateByKeys({ keys: this.props.keys, type: type || "fa" })
  }
  getTemplate = (successCallback: (file: any) => void, type?: "en" | "fa") => {
    const cc = new AIOConvert()
    cc.getTemplateByKeys({
      keys: this.props.keys,
      type: type || "fa",
      successCallback,
    })
  }
  render = (file: any) => {
    return <DataProvider {...this.props} file={file} />
  }
}
const DataProvider: FC<I_BoxitExcel & { file: any }> = (props) => {
  const [apis, setApis] = useState<APIS>()
  const [dic] = useState<I_dic>(getFaDic)
  const [cc] = useState<AIOConvert>(new AIOConvert())
  function getFaDic() {
    let res: any = { en2fa: {}, fa2en: {} }
    for (let key of props.keys) {
      if (key.en) {
        res.en2fa[key.en] = key.fa
      }
      if (key.fa) {
        res.fa2en[key.fa] = key.en
      }
    }
    return res
  }
  const getToken = () => {
    const token = localStorage.getItem("token")
    if (!token) {
      setTimeout(() => getToken(), 500)
    } else {
      setApis(
        new APIS({ validateUrl: props.validateUrl, token, keys: props.keys })
      )
    }
  }
  useEffect(() => {
    getToken()
  }, [])
  if (!apis) {
    return null
  }
  return <BoxitExcelComponent {...props} apis={apis} dic={dic} cc={cc} />
}
const BoxitExcelComponent: FC<
  I_BoxitExcel & { file: any; apis: APIS; dic: I_dic; cc: AIOConvert }
> = (props) => {
  const { errorStyle = { background: "#ff0000" } } = props
  const { apis, dic, cc } = props
  const popup = usePopup()
  const [link, setLink] = useState<{ click: () => void }>()
  const [downloaded, setDownloaded] = useState<boolean>(false)
  const [apiError, setApiError] = useState<string>("")
  const [columnsErrors, setColumnsErrors] = useState<string[]>([])
  const [errorsLength, setErrorsLength] = useState<number>()
  useEffect(() => {
    excelToJson()
  }, [props.file])
  const getStyleList = (errors: I_error[]) =>
    errors.map((o) => ({
      recordIndex: o.recordIndex,
      field: dic.en2fa[o.field],
      style: errorStyle,
    }))
  function excelToJson() {
    cc.checkExcelColumns(
      props.file,
      props.keys.map((o) => o.fa),
      (errors) => {
        if (errors.length) {
          popup.addAlert({
            type: "error",
            time: 300,
            title: "مغایرت در فایل اکسل آپلود شده",
            text: `
                            <ul style="text-align:right;">
                                ${errors.join(" ")}
                            </ul>
                        `,
          })
          setColumnsErrors(errors || [])
        } else {
          cc.excel2json(
            props.file,
            async (res: any) => {
              const p: any = { jsonData: res, keys: props.keys, from: "fa" }
              const enJson = cc.convertJson({
                ...p,
                to: "en",
                extend: props.extendRowToServer,
              })
              const faJson = cc.convertJson({ ...p, to: "fa" })
              const errors: I_error[] | false = await apis.validate(
                enJson,
                (apiError) => {
                  setApiError(apiError)
                }
              )
              if (errors === false) {
                return
              }
              setErrorsLength(errors.length)
              const styleList = getStyleList(errors)
              if (errors.length) {
                setLink({
                  click: () =>
                    cc.json2excel({
                      jsonData: faJson,
                      styleList,
                      successCallback: (excelFile) => {
                        cc.downloadFile(excelFile)
                        setDownloaded(true)
                      },
                    }),
                })
              } else {
                props.onSuccess(enJson)
              }
            },
            (error: any) => {
              console.log(error)
            }
          )
        }
      },
      (error) => {
        alert(error)
      }
    )
  }
  const getText = (index: number, v?: any) => {
    return [
      "بازگشت",
      "دانلود فایل اکسل با خطا های مشخص شده",
      `فایل اکسل دارای ${v} خطا می باشد`,
      "فایل اکسل با خطا های مشخص شده دانلود شد.",
      "در حال بارگذاری",
    ][index]
  }
  const backButton = () => (
    <button
      className="boxit-excel-button boxit-excel-back-button"
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        props.onClose()
      }}
    >
      {getText(0)}
    </button>
  )
  const downloadButton = () => (
    <button className="boxit-excel-button" onClick={() => link?.click()}>
      {getText(1)}
    </button>
  )
  const errorsLabel = () => (
    <div className="msf">{getText(2, errorsLength)}</div>
  )
  function getContent() {
    if (!!columnsErrors.length) {
      return (
        <div className="boxit-excel-error">{`${columnsErrors.length} مورد مغایرت`}</div>
      )
    }
    if (apiError) {
      return <div className="boxit-excel-error">{apiError}</div>
    }
    if (downloaded) {
      return <div className="boxit-excel-info">{getText(3)}</div>
    }
    if (errorsLength === undefined) {
      return <div className="boxit-excel-loading">{getText(4)}</div>
    }
    if (errorsLength) {
      return (
        <>
          <div className="boxit-excel-error">{errorsLabel()}</div>{" "}
          {downloadButton()}{" "}
        </>
      )
    }
    return null
  }
  return (
    <div className="boxit-excel">
      {getContent()}
      {backButton()}
    </div>
  )
}

class APIS {
  keys: I_key[]
  request: AIOApis["request"]
  validateUrl: string
  constructor(p: { token: string; validateUrl: string; keys: I_key[] }) {
    this.keys = p.keys
    this.validateUrl = p.validateUrl
    const inst = new AIOApis({
      id: "exv",
      token: p.token,
      lang: "fa",
      handleErrorMessage: (r) => {
        const messages = r?.response?.data?.messages || []
        let message = ""
        if (messages[0] && messages[0].message) {
          message = messages[0].message
        } else if (r.message) {
          message = r.message
        } else {
          message = "خطای نا مشخص"
        }
        return message
      },
    })
    this.request = inst.request
  }
  validate = async (rows: any[], errorCallback: (message: string) => void) => {
    const phoneErrors = this.validatePhoneNumbers(rows)
    const { success, response, errorMessage } = await this.request<{
      data: { payload: I_error[] }
    }>({
      name: "validate",
      description: "اعتبار سنجی اکسل",
      body: rows,
      method: "post",
      showError: false,
      url: this.validateUrl,
    })
    if (!success) {
      errorCallback(errorMessage)
      return false
    } else {
      const serverErrors = response.data.payload
      const allErrors = [...phoneErrors, ...serverErrors]
      return allErrors
    }
  }
  validatePhoneNumbers = (rows: any[]): I_error[] => {
    const errors: I_error[] = []
    const phoneRegex = /^(?:\+989|09|9)\d{9}$/

    rows.forEach((row, index) => {
      if (row.receiverMobile) {
        const phone = String(row.receiverMobile).replace(/\s+/g, "")
        if (!phoneRegex.test(phone)) {
          errors.push({
            recordIndex: index + 1,
            error: `شماره موبایل "${row.receiverMobile}" فرمت صحیح ندارد. فرمت صحیح: 09XXXXXXXXX`,
            field: "receiverMobile",
          })
        }
      } else {
        errors.push({
          recordIndex: index + 1,
          error: "شماره موبایل گیرنده الزامی است",
          field: "receiverMobile",
        })
      }
    })

    return errors
  }
}
type I_convertJsonParam = {
  jsonData: any
  keys: I_key[]
  from: "en" | "fa"
  to: "en" | "fa"
  extend?: (row: any, index: number) => any
}
type I_excelStyle = {
  background?: string
  fontWeight?: "bold"
  fontFamily?: string
  fontSize?: number
  color?: string
  border?: string
  borderLeft?: string
  borderRight?: string
  borderBottom?: string
  borderTop?: string
  alignItems?: "flex-start" | "center" | "flex-end"
  justifyContent?: "flex-start" | "center" | "flex-end"
  flexWrap?: "wrap"
  display?: "none"
}
class AIOConvert {
  excel2json = (
    file: any,
    successCallback: (jsonData: any) => void,
    errorCallback: (message: string) => void
  ) => {
    const reader = new FileReader()
    reader.onload = async function (e: any) {
      try {
        const data = new Uint8Array(e.target.result),
          workbook: any = new ExcelJS.Workbook()
        await workbook.xlsx.load(data)
        const worksheet = workbook.worksheets[0]
        const jsonData: any = []
        let headers: any = []
        worksheet.eachRow((row: any, rowIndex: any) => {
          if (rowIndex === 1) {
            headers = row.values
          } else {
            const rowData: any = {}
            row.values.forEach((value: any, colIndex: any) => {
              const header = headers[colIndex]
              if (header) {
                rowData[header] = value
              }
            })
            jsonData.push(rowData)
          }
        })
        successCallback(jsonData)
      } catch (error: any) {
        errorCallback(`فایل اکسل دارای مشکل نا شناخته می باشد : ${error}`)
      }
    }
    reader.onerror = function (error: any) {
      errorCallback(error)
    }
    reader.readAsArrayBuffer(file)
  }
  checkExcelColumns = (
    file: any,
    columns: (string | undefined)[],
    successCallback: (errors: string[]) => void,
    errorCallback: (message: string) => void
  ) => {
    const reader = new FileReader()
    reader.onload = async function (e: any) {
      try {
        const data = new Uint8Array(e.target.result),
          workbook: any = new ExcelJS.Workbook()
        await workbook.xlsx.load(data)
        const worksheet = workbook.worksheets[0]
        const existingColumns: string[] = []
        worksheet.eachRow((row: any, rowIndex: any) => {
          if (rowIndex === 1) {
            row.values.forEach((key: any) => {
              if (key) {
                existingColumns.push(key)
              }
            })
          }
        })
        const errors: string[] = []
        columns.forEach((column) => {
          if (!!column && !existingColumns.includes(column)) {
            let same = existingColumns.find((ec) => {
              return column.replace(/\s+/g, "") === ec.replace(/\s+/g, "")
            })
            const styleStr =
              'style="background: #b7b7b750;padding: 6px;border-radius: 6px;font-size: 10px;margin-bottom:3px;"'
            if (same) {
              errors.push(`
                                <li ${styleStr}>در فایل اکسل ستون <highlight style='background:#ff000038;'>"${same}"</highlight> باید با ستون <highlight style='background:#00ff5a38;'>"${column}"</highlight> جایگزین شود</li>
                            `)
            } else {
              errors.push(
                `<li ${styleStr}>ستون "${column}" در فایل اکسل موجود نیست.</li>`
              )
            }
          }
        })
        successCallback(errors)
      } catch (error: any) {
        errorCallback(`فایل اکسل دارای مشکل نا شناخته می باشد : ${error}`)
      }
    }
    reader.onerror = function (error: any) {
      errorCallback(error)
    }
    reader.readAsArrayBuffer(file)
  }
  getExcelBorderStyle = (
    cssBorder: string
  ): { style: "thin" | "medium" | "thick"; color: { argb: string } } => {
    const [borderWidth, borderStyle, borderColor] = cssBorder.split(" ")
    let px = +borderWidth
    if (px < 1) {
      px = 1
    } else if (px > 3) {
      px = 3
    }
    const sizeStr = ["thin", "medium", "thick"][px - 1] as
      | "thin"
      | "medium"
      | "thick"
    return { style: sizeStr, color: { argb: this.cssToARGB(borderColor) } }
  }
  setExcelCellStyle = (cell: any, style: I_excelStyle) => {
    if (style.background) {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: this.cssToARGB(style.background) },
      }
    }
    let font: {
      bold?: boolean
      name?: string
      size?: number
      color?: { argb: string }
    } = {}
    let hasFont = false
    if (style.fontWeight === "bold") {
      font.bold = true
      hasFont = true
    }
    if (style.fontFamily) {
      font.name = style.fontFamily
      hasFont = true
    }
    if (style.fontSize) {
      font.size = style.fontSize
      hasFont = true
    }
    if (style.color) {
      font.color = { argb: this.cssToARGB(style.color) }
      hasFont = true
    }
    if (hasFont) {
      cell.font = font
    }

    let border: {
      top?: { style: string; color: { argb: string } }
      left?: { style: string; color: { argb: string } }
      bottom?: { style: string; color: { argb: string } }
      right?: { style: string; color: { argb: string } }
    } = {}
    let hasBorder = false
    if (style.borderTop) {
      border.top = this.getExcelBorderStyle(style.borderTop)
      hasBorder = true
    }
    if (style.borderBottom) {
      border.bottom = this.getExcelBorderStyle(style.borderBottom)
      hasBorder = true
    }
    if (style.borderLeft) {
      border.left = this.getExcelBorderStyle(style.borderLeft)
      hasBorder = true
    }
    if (style.borderRight) {
      border.right = this.getExcelBorderStyle(style.borderRight)
      hasBorder = true
    }
    if (hasBorder) {
      cell.border = border
    }

    let align: {
      horizontal?: "center" | "left" | "right"
      vertical?: "middle" | "top" | "bottom"
      wrapText?: boolean
    } = {}
    let hasAlign = false
    if (style.alignItems) {
      align.vertical = {
        center: "middle",
        "flex-start": "top",
        "flex-end": "bottom",
      }[style.alignItems] as any
      hasAlign = true
    }
    if (style.justifyContent) {
      align.vertical = {
        center: "center",
        "flex-start": "left",
        "flex-end": "right",
      }[style.justifyContent] as any
      hasAlign = true
    }
    if (style.flexWrap === "wrap") {
      align.wrapText = true
    }
    if (hasAlign) {
      cell.alignment = align
    }
    if (style.display === "none") {
      cell.hidden = true
    }
  }
  downloadFile = (file: any, fileName?: string) => {
    const blob = new Blob([file], { type: "application/octet-stream" })
    if (!fileName) {
      let pr = window.prompt("نام فایل جدید را وارد کنید")
      pr = !pr || pr === null ? "untitle" : pr
      fileName = pr
    }
    saveAs(blob, `${fileName}.xlsx`)
  }
  cssToARGB = (cssColor: string) => {
    let alpha = "FF"
    if (cssColor.startsWith("#")) {
      let hex = cssColor.replace("#", "")
      if (hex.length === 3) {
        hex = hex
          .split("")
          .map((ch) => ch + ch)
          .join("")
      }
      return alpha + hex.toUpperCase()
    } else if (cssColor.startsWith("rgb")) {
      const match = cssColor.match(/\d+/g)
      if (match) {
        const [r, g, b] = match.map((num) =>
          parseInt(num).toString(16).padStart(2, "0")
        )
        return alpha + r.toUpperCase() + g.toUpperCase() + b.toUpperCase()
      }
    }
    return ""
  }
  getTemplateByKeys = (p: {
    keys: I_key[]
    type: "en" | "fa"
    successCallback?: (file: any) => void
  }) => {
    let jsonRow: any = {}
    for (let key of p.keys) {
      const v = key[p.type]
      if (v !== undefined) {
        jsonRow[v] = key.defaultValue === undefined ? "" : key.defaultValue
      }
    }
    this.json2excel({
      jsonData: [jsonRow],
      successCallback: (file) => {
        if (p.successCallback) {
          p.successCallback(file)
        } else {
          this.downloadFile(file)
        }
      },
    })
  }
  fix = (key: string) => {
    try {
      key = key.replace(/['"]/g, "")
    } catch {}
    try {
      key = key.trim()
    } catch {}
    return key
  }
  fixRowKeys = (row: any) => {
    let res: any = {}
    for (let prop in row) {
      res[this.fix(prop)] = row[prop]
    }
    return res
  }
  convertJson = (p: I_convertJsonParam) => {
    const { jsonData, keys, from, to, extend = (row) => row } = p
    return jsonData.map((row: any, i: number) => {
      row = this.fixRowKeys(row)
      let res: any = {}
      for (let j = 0; j < keys.length; j++) {
        const key = keys[j],
          f = key[from],
          t = key[to]
        const { nullValue = () => null } = key
        if (t === undefined || f === undefined) {
          continue
        }
        let cellValue = row[f]
        cellValue = cellValue === undefined ? nullValue(i) : cellValue
        res[t] = cellValue
      }
      res = extend(res, i)
      return res
    })
  }
  json2excel(p: {
    jsonData: any
    styleList?: { recordIndex: number; field: string; style?: I_excelStyle }[]
    successCallback: (file: any) => void
  }) {
    function getFieldColumnIndex(jsonRow: any, field: string) {
      return Object.keys(jsonRow).indexOf(field)
    }
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet("Sheet1")
    worksheet.columns = Object.keys(p.jsonData[0]).map((key) => ({
      header: key,
      key,
    }))
    p.jsonData.forEach((row: any) => worksheet.addRow(row))
    ;(p.styleList || []).forEach(({ recordIndex, field, style }) => {
      const columnIndex = getFieldColumnIndex(p.jsonData[0], field) + 1
      const cell = worksheet.getRow(recordIndex + 1).getCell(columnIndex)
      if (style) {
        this.setExcelCellStyle(cell, style)
      }
    })
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      p.successCallback(buffer)
    })
  }
}

const useExcel = (config: I_BoxitExcel) => {
  const instRef = useRef<BoxitExcel>(new BoxitExcel(config))
  return instRef.current.render
}
export default useExcel
